import { useMutation } from "@tanstack/react-query";
import { postBankingAuthWarmUp } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

/**
 * Asks the backend to fetch the bank token for the given account ahead of the pay request. Best effort and quiet:
 * no error reporting, a failure changes nothing for the payment.
 */
export const useWarmUpBankToken = () =>
  useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      (bankAccountPublicID: string) =>
        postBankingAuthWarmUp(bankAccountPublicID),
    ),
    meta: { skipErrorReporting: true },
  });
